import { apiRequest } from '../utils/useAPIRequest';
import WalletController from './WalletController';
import constant from '../utils/constant';
import { payrollStore } from '../stores';
import moment from 'moment';

const getPayrollsGroupByMonth = async () => {
	const startDate = moment().startOf('year');
	const endDate = moment().endOf('month');
	const { status, data, errorMessage } = await apiRequest({
		url: `/payrolls/business?startDate=${startDate}&endDate=${endDate}&dateField=createdAt`,
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setGroupPayrolls(data);
		return { status };
	}
	return { status, errorMessage };
};

const getPayrollList = async query => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/payrolls/business/list?${query}`,
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setPayrolls(data.payrolls);
		return { status };
	}
	return { status, errorMessage };
};

const payrollSummaries = async query => {
	if (!query) {
		query = `tag=${payrollStore.tags?.[0]?.value || ''}`;
	}

	const { status, data, errorMessage } = await apiRequest({
		url: `/payrolls/summary?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		payrollStore.setPayrollSummaries(data);
		return { status, data };
	}
	return { status, errorMessage };
};

const getPayrollById = async id =>
	await apiRequest({ url: `/payrolls/payroll/${id}`, method: 'get' });

const updatePayrollStatus = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: `/payrolls/payroll/status`,
		method: 'put',
		payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
		Promise.all([
			// getPayrollsGroupByMonth(),
			payrollSummaries(),
			WalletController.walletDetails(),
		]);
		return { status };
	}
	return { status, errorMessage };
};
const getPayrollCost = async ids =>
	await apiRequest({
		url: '/payrolls/payroll-cost',
		method: 'post',
		payload: { ids },
	});
const updateConfiguredPayroll = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/configure-payrolls/${id}`,
		method: 'patch',
		payload: payload,
	});
	if (status === constant.Success) {
		await getConfiguredPayroll();
	}
	return { status, errorMessage };
};

const configurePayroll = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/configure-payrolls',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		await getConfiguredPayroll();
	}
	return { status, errorMessage };
};
const reviewerBulkRequestChange = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/reviewer-bulk-request-change',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const setVoid = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/set-void',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const setIgnoreOrPending = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/set-ignore-or-pending',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const approverBulkRequestChange = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/approver-bulk-request-change',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const requestReview = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/request-review',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const requestApproval = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/request-approval',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const approverRequestChange = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/request-one-change-by-approver',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};
const reviewerRequestChange = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/request-one-change-by-reviewer',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const approve = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/approve',
		method: 'post',
		payload: payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await getPayrollList(`tag=${tag}`);
	}
	return { status, errorMessage };
};

const getConfiguredPayroll = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/configure-payrolls/business',
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setPayrollConfigurations(data.value);
	}
	return { status, errorMessage };
};

const getTags = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/payrolls/tags',
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setMapTags(
			data.map(group => {
				return {
					key: group,
					value: group,
				};
			})
		);
	}
	return { status, errorMessage };
};

const updatePayroll = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/payrolls/payroll/${id}`,
		method: 'put',
		payload,
	});
	if (status === constant.Success) {
		const tag = localStorage.getItem('tagValue');
		await Promise.all([
			getPayrollList(`tag=${tag}`),
			// getPayrollsGroupByMonth(),
			payrollSummaries(),
		]);
		return { status };
	}
	return { status, errorMessage };
};

const bulkDeductionOrAddition = async payload => {
	const tag = localStorage.getItem('tagValue');
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/payroll/bulk/update-same-amount',
		method: 'put',
		payload,
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getPayrollList(`tag=${tag}`);
				Promise.all([
					// getPayrollsGroupByMonth(),
					payrollSummaries(),
				]);
				resolve({ status });
			}, 4000)
		);

		return await process;
	}
	return { status, errorMessage };
};
const uploadSalesSheet = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/payrolls/upload-sales-sheet',
		method: 'post',
		payload,
		hasImageUpload: true,
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getSalesList();
				resolve({ status });
			}, 3000)
		);

		return await process;
	}
	return { status, errorMessage };
};
const uploadProductsConfig = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/configure-payrolls/bulk-product-sales',
		method: 'post',
		payload,
		hasImageUpload: true,
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getProductList();
				resolve({ status });
			}, 3000)
		);

		return await process;
	}
	return { status, errorMessage };
};
const getSalesList = async query => {
	if (!query) {
		const startDate = moment().startOf('month');
		const endDate = moment().endOf('month');
		query = `dateField=salesDate&startDate=${startDate}&endDate=${endDate}`;
	}
	const { status, data, errorMessage } = await apiRequest({
		url: `/payrolls/sales/business?${query}`,
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setSalesList(data.sales);
	}
	return { status, errorMessage };
};
const getProductList = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/configure-payrolls/productConfigs',
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setProductSalesList(data.value);
	}
	return { status, errorMessage };
};
const getDeductions = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/configure-payrolls/deductions/business',
		method: 'get',
	});
	if (status === constant.Success) {
		payrollStore.setDeductions(data);
	}
	return { status, errorMessage };
};
const updateProductsConfig = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/configure-payrolls/products/${id}`,
		method: 'patch',
		payload,
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getProductList();
				resolve({ status });
			}, 3000)
		);

		return await process;
	}
	return { status, errorMessage };
};
const refresh = async () => {
	const tag = localStorage.getItem('tagValue');
	const { status, data, errorMessage } = await apiRequest({
		url: `/payrolls/refresh?tag=${tag}`,
		method: 'get',
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getTags();
				await getPayrollList(`tag=${tag}`);
				Promise.all([
					// getPayrollsGroupByMonth(),
					payrollSummaries(),
				]);
				resolve({ status, data });
			}, 2000)
		);

		return await process;
	}
	return { status, errorMessage };
};
const createPayroll = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/payrolls/payroll',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		const process = new Promise(resolve =>
			setTimeout(async () => {
				await getTags();
				await getPayrollList(`tag=${payrollStore?.tags?.[0]?.value}`);
				Promise.all([
					// getPayrollsGroupByMonth(),
					payrollSummaries(),
				]);
				resolve({ status, data });
			}, 2000)
		);

		return await process;
	}
	return { status, errorMessage };
};

const createDeduction = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/configure-payrolls/create-deduction',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await getDeductions();

		return { status };
	}
	return { status, errorMessage };
};

const PayrollController = {
	createPayroll,
	createDeduction,
	getDeductions,
	bulkDeductionOrAddition,
	updateConfiguredPayroll,
	reviewerBulkRequestChange,
	approverBulkRequestChange,
	approve,
	getConfiguredPayroll,
	updatePayroll,
	setIgnoreOrPending,
	getTags,
	setVoid,
	getSalesList,
	configurePayroll,
	requestApproval,
	requestReview,
	getPayrollCost,
	payrollSummaries,
	updatePayrollStatus,
	getPayrollById,
	getPayrollsGroupByMonth,
	getPayrollList,
	approverRequestChange,
	reviewerRequestChange,
	uploadProductsConfig,
	uploadSalesSheet,
	updateProductsConfig,
	getProductList,
	refresh,
};

export default PayrollController;
